import { render, staticRenderFns } from "./AdManage.vue?vue&type=template&id=2f6f9ba0&scoped=true&"
import script from "./AdManage.vue?vue&type=script&lang=js&"
export * from "./AdManage.vue?vue&type=script&lang=js&"
import style0 from "./AdManage.vue?vue&type=style&index=0&id=2f6f9ba0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f9ba0",
  null
  
)

export default component.exports